module.exports = __webpack_public_path__ + "img/praying-hands.3e951854.svg";